var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RenderBlock } from '../../render-layout.models';
/** Lottery prize breakdown - template-3 variant: standalone desktop prize table + square advert. */
var LotteryPrizeBreakdownT3 = /** @class */ (function (_super) {
    __extends(LotteryPrizeBreakdownT3, _super);
    function LotteryPrizeBreakdownT3() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LotteryPrizeBreakdownT3;
}(RenderBlock));
export { LotteryPrizeBreakdownT3 };
